


import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
        Icon,
    },
})

export default class PartialIcon extends Vue {

  private iconEnum = IconEnum;
  private iconEnumObj: any = [];

  private created() {
    const enumKeys = Object.keys(this.iconEnum);
    enumKeys.map((key) => this.iconEnumObj.push({ key, iconClass: (this.iconEnum as any)[key] }) );
  }

}
